<template>
  <SharedLayout>
    <!-- Preloader Start -->
    
    <!-- Back To Top Start -->
    

    <!-- fix-area Start -->
   

    <!-- Sidebar Area Here -->
   

    <!-- Hero Section Start -->
    <section class="hero-section-2">
      <div class="arrow-button">
        <button class="array-prev">
          <i class="fa-light fa-chevron-left"></i>
        </button>
        <button class="array-next">
          <i class="fa-light fa-chevron-right"></i>
        </button>
      </div>
      <div class="swiper hero-slider">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <div class="hero-2">
              <div class="hero-bg bg-cover" style="background-image: url(/assets/img/hero/bg.jpg);">
              </div>
              <div class="container-fluid">
                <div class="row g-4">
                  <div class="col-lg-10">
                    <div class="hero-content">
                      <p data-animation="fadeInUp" data-delay="1.3s">Up To 20% Off</p>
                      <h1 data-animation="fadeInUp" data-delay="1.5s">
                        Discover the beauty <br> within You!
                      </h1>
                      <div class="hero-icon-item" data-animation="fadeInUp" data-delay="1.7s">
                        <div class="icon-item style-2">
                          <div class="icon">
                            <img src="/assets/img/icon/09.svg" alt="img">
                          </div>
                          <div class="content">
                            <h6>
                              High-end <br>
                              Cosmetics
                            </h6>
                          </div>
                        </div>
                        <div class="icon-item style-2">
                          <div class="icon">
                            <img src="/assets/img/icon/10.svg" alt="img">
                          </div>
                          <div class="content">
                            <h6>
                              Vegan <br>
                              Product
                            </h6>
                          </div>
                        </div>
                        <div class="icon-item style-2">
                          <div class="icon">
                            <img src="/assets/img/icon/12.svg" alt="img">
                          </div>
                          <div class="content">
                            <h6>
                              Express <br>
                              Make-up
                            </h6>
                          </div>
                        </div>
                      </div>
                      <div class="hero-button" data-animation="fadeInUp" data-delay="1.3s">
                        <a href="/contact" class="theme-btn">Discover Now <i class="fa-regular fa-arrow-right"></i></a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-slide">
            <div class="hero-2">
              <div class="hero-bg bg-cover" style="background-image: url(/assets/img/hero/bg-6.jpg);">
              </div>
              <div class="container-fluid">
                <div class="row g-4">
                  <div class="col-lg-10">
                    <div class="hero-content">
                      <p data-animation="fadeInUp" data-delay="1.3s">Up To 20% Off</p>
                      <h1 data-animation="fadeInUp" data-delay="1.5s">
                        Discover the beauty <br> within You!
                      </h1>
                      <div class="hero-icon-item" data-animation="fadeInUp" data-delay="1.7s">
                        <div class="icon-item style-2">
                          <div class="icon">
                            <img src="/assets/img/icon/09.svg" alt="img">
                          </div>
                          <div class="content">
                            <h6>
                              High-end <br>
                              Cosmetics
                            </h6>
                          </div>
                        </div>
                        <div class="icon-item style-2">
                          <div class="icon">
                            <img src="/assets/img/icon/10.svg" alt="img">
                          </div>
                          <div class="content">
                            <h6>
                              Vegan <br>
                              Product
                            </h6>
                          </div>
                        </div>
                        <div class="icon-item style-2">
                          <div class="icon">
                            <img src="/assets/img/icon/12.svg" alt="img">
                          </div>
                          <div class="content">
                            <h6>
                              Express <br>
                              Make-up
                            </h6>
                          </div>
                        </div>
                      </div>
                      <div class="hero-button" data-animation="fadeInUp" data-delay="1.3s">
                        <a href="/contact" class="theme-btn">Discover Now <i class="fa-regular fa-arrow-right"></i></a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-slide">
            <div class="hero-2">
              <div class="hero-bg bg-cover" style="background-image: url(/assets/img/hero/bg-5.jpg);">
              </div>
              <div class="container-fluid">
                <div class="row g-4">
                  <div class="col-lg-10">
                    <div class="hero-content">
                      <p data-animation="fadeInUp" data-delay="1.3s">Up To 20% Off</p>
                      <h1 data-animation="fadeInUp" data-delay="1.5s">
                        Discover the beauty <br> within You!
                      </h1>
                      <div class="hero-icon-item" data-animation="fadeInUp" data-delay="1.7s">
                        <div class="icon-item style-2">
                          <div class="icon">
                            <img src="/assets/img/icon/09.svg" alt="img">
                          </div>
                          <div class="content">
                            <h6>
                              High-end <br>
                              Cosmetics
                            </h6>
                          </div>
                        </div>
                        <div class="icon-item style-2">
                          <div class="icon">
                            <img src="/assets/img/icon/10.svg" alt="img">
                          </div>
                          <div class="content">
                            <h6>
                              Vegan <br>
                              Product
                            </h6>
                          </div>
                        </div>
                        <div class="icon-item style-2">
                          <div class="icon">
                            <img src="/assets/img/icon/12.svg" alt="img">
                          </div>
                          <div class="content">
                            <h6>
                              Express <br>
                              Make-up
                            </h6>
                          </div>
                        </div>
                      </div>
                      <div class="hero-button" data-animation="fadeInUp" data-delay="1.3s">
                        <a href="/contact" class="theme-btn">Discover Now <i class="fa-regular fa-arrow-right"></i></a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Sop-category Section Start -->
    <section class="sop-category-section section-padding fix">
      <div class="container">
        <div class="section-title text-center style-3">
          <h6 class="sub-title wow fadeInUp">
            Shop by Category
          </h6>
          <h2 class="wow fadeInUp" data-wow-delay=".3s">
            Best sellers in beauty
          </h2>
        </div>
        <div class="swiper category-slider">
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <div class="shop-category-item">
                <div class="shop-category-image">
                  <img src="/assets/img/shop/08.jpg" alt="img">
                  <div class="content">
                    <h3>
                      <a href="/shop">Cleansers</a>
                    </h3>
                    <p>8 Products</p>
                    <a href="/shop" class="link-btns style-2">View Now <i class="fa-solid fa-chevron-right"></i></a>
                  </div>
                </div>
              </div>
            </div>
            <div class="swiper-slide">
              <div class="shop-category-item">
                <div class="shop-category-image">
                  <img src="/assets/img/shop/09.jpg" alt="img">
                  <div class="content">
                    <h3>
                      <a href="/shop">Face Sunscreen</a>
                    </h3>
                    <p>8 Products</p>
                    <a href="/shop" class="link-btns style-2">View Now <i class="fa-solid fa-chevron-right"></i></a>
                  </div>
                </div>
              </div>
            </div>
            <div class="swiper-slide">
              <div class="shop-category-item">
                <div class="shop-category-image">
                  <img src="/assets/img/shop/10.jpg" alt="img">
                  <div class="content">
                    <h3>
                      <a href="/shop">Face Sunscreen</a>
                    </h3>
                    <p>Conditioners</p>
                    <a href="/shop" class="link-btns style-2">View Now <i class="fa-solid fa-chevron-right"></i></a>
                  </div>
                </div>
              </div>
            </div>
            <div class="swiper-slide">
              <div class="shop-category-item">
                <div class="shop-category-image">
                  <img src="/assets/img/shop/11.jpg" alt="img">
                  <div class="content">
                    <h3>
                      <a href="/shop">Masks</a>
                    </h3>
                    <p>Conditioners</p>
                    <a href="/shop" class="link-btns style-2">View Now <i class="fa-solid fa-chevron-right"></i></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="arrow-button">
          <button class="array-prev">
            <i class="fa-light fa-chevron-left"></i>
          </button>
          <button class="array-next">
            <i class="fa-light fa-chevron-right"></i>
          </button>
        </div>
      </div>
    </section>

    <!-- Product-box Section Start -->
    <section class="product-box-section section-padding pt-0 fix">
      <div class="container">
        <div class="row g-0">
          <div class="col-xl-4 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay=".3s">
            <div class="product-box-item style-2">
              <div class="product-image">
                <img src="/assets/img/product/13.png" alt="img">
              </div>
              <div class="product-content">
                <h3>
                  <a href="/product-details/1">Super Boost <br>
                    Moisturizing Lip Gloss</a>
                </h3>
                <p>
                  Molestias internos et commodi tempora <br> dolores sapiente sed iste.
                </p>
                <span>Save $72</span>
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay=".s">
            <div class="product-box-item">
              <div class="product-image">
                <img src="/assets/img/product/14.png" alt="img">
              </div>
              <div class="product-content">
                <h3>
                  <a href="/product-details/1">Mini Glycolic <br>
                    Acid 7% Exfoliating Toner</a>
                </h3>
                <p>
                  Molestias internos et commodi tempora <br> dolores sapiente sed iste.
                </p>
                <span>Save $72</span>
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay=".7s">
            <div class="product-box-item mb-0">
              <div class="product-image">
                <img src="/assets/img/product/15.png" alt="img">
              </div>
              <div class="product-content">
                <h3>
                  <a href="/product-details/1">Mini Radiant Creamy <br>
                    Concealer with Medium
                  </a>
                </h3>
                <p>
                  Molestias internos et commodi tempora <br> dolores sapiente sed iste.
                </p>
                <span>Save $72</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Product-collection Section Start -->
    <section class="product-collection-section section-bg section-padding fix">
      <div class="container">
        <div class="section-title-area">
          <div class="section-title style-3">
            <h6 class="sub-title wow fadeInUp">
              Product Collection
            </h6>
            <h2 class="wow fadeInUp" data-wow-delay=".3s">
              Discover our products
            </h2>
          </div>
          <a href="/product-details/1" class="theme-btn theme-btn-3">Shop All Products <i class="fa-regular fa-arrow-right"></i></a>
        </div>
        <div class="tab-content">
          <div class="row">
            <div class="col-xl-3 col-lg-4 col-md-6 wow fadeInUp" data-wow-delay=".2s">
              <div class="product-collection-item">
                <div class="product-image">
                  <img src="/assets/img/product/16.jpg" alt="img">
                  <div class="product-btn">
                    <a href="/shop-cart" class="theme-btn-2">Add To Cart</a>
                  </div>
                </div>
                <div class="product-content">
                  <p>Retinol 24</p>
                  <h4>
                    <a href="/product-details/1">Face Wash by Olay Regenerist</a>
                  </h4>
                  <span>$19.00</span>
                </div>
              </div>
            </div>
            <div class="col-xl-3 col-lg-4 col-md-6 wow fadeInUp" data-wow-delay=".4s">
              <div class="product-collection-item">
                <div class="product-image">
                  <img src="/assets/img/product/17.jpg" alt="img">
                  <div class="badge">26%</div>
                  <div class="product-btn">
                    <a href="/shop-cart" class="theme-btn-2">Add To Cart</a>
                  </div>
                </div>
                <div class="product-content">
                  <p>Retinol 24</p>
                  <h4>
                    <a href="/product-details/1">Kabuki Makeup Brush</a>
                  </h4>
                  <ul class="doller">
                    <li>
                      $19.00 <del>$27.00</del>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="col-xl-3 col-lg-4 col-md-6 wow fadeInUp" data-wow-delay=".6s">
              <div class="product-collection-item">
                <div class="product-image">
                  <img src="/assets/img/product/18.jpg" alt="img">
                  <div class="product-btn">
                    <a href="/shop-cart" class="theme-btn-2">Add To Cart</a>
                  </div>
                </div>
                <div class="product-content">
                  <p>Coola</p>
                  <h4>
                    <a href="/product-details/1">Organic Face Sunscreen</a>
                  </h4>
                  <span>$44.00</span>
                </div>
              </div>
            </div>
            <div class="col-xl-3 col-lg-4 col-md-6 wow fadeInUp" data-wow-delay=".8s">
              <div class="product-collection-item">
                <div class="product-image">
                  <img src="/assets/img/product/19.jpg" alt="img">
                  <div class="badge">35%</div>
                  <div class="product-btn">
                    <a href="/shop-cart" class="theme-btn-2">Add To Cart</a>
                  </div>
                </div>
                <div class="product-content">
                  <p>Fanning</p>
                  <h4>
                    <a href="/shop-cart">Pure Cosmetics Lip Gloss</a>
                  </h4>
                  <ul class="doller">
                    <li>
                      $23.00 <del>$25.00</del>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="col-xl-3 col-lg-4 col-md-6 wow fadeInUp" data-wow-delay=".2s">
              <div class="product-collection-item">
                <div class="product-image">
                  <img src="/assets/img/product/20.jpg" alt="img">
                  <div class="badge">14%</div>
                  <div class="product-btn">
                    <a href="/shop-cart" class="theme-btn-2">Add To Cart</a>
                  </div>
                </div>
                <div class="product-content">
                  <p>Mineral </p>
                  <h4>
                    <a href="/product-details/1">Mineral Matte Finishing</a>
                  </h4>
                  <ul class="doller">
                    <li>
                      $16.00 <del>$22.00</del>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="col-xl-3 col-lg-4 col-md-6 wow fadeInUp" data-wow-delay=".4s">
              <div class="product-collection-item">
                <div class="product-image">
                  <img src="/assets/img/product/21.jpg" alt="img">
                  <div class="product-btn">
                    <a href="/shop-cart" class="theme-btn-2">Add To Cart</a>
                  </div>
                </div>
                <div class="product-content">
                  <p>Night Face</p>
                  <h4>
                    <a href="/product-details/1">Retinol Value Set Duo</a>
                  </h4>
                  <span>
                    $76.00
                  </span>
                </div>
              </div>
            </div>
            <div class="col-xl-3 col-lg-4 col-md-6 wow fadeInUp" data-wow-delay=".6s">
              <div class="product-collection-item">
                <div class="product-image">
                  <img src="/assets/img/product/22.jpg" alt="img">
                  <div class="badge">40%</div>
                  <div class="product-btn">
                    <a href="/shop-cart" class="theme-btn-2">Add To Cart</a>
                  </div>
                </div>
                <div class="product-content">
                  <p>Coty Airspun</p>
                  <h4>
                    <a href="/product-details/1">Airspun Loose Face Powder</a>
                  </h4>
                  <ul class="doller">
                    <li>
                      $124.00 <del>$126.00</del>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="col-xl-3 col-lg-4 col-md-6 wow fadeInUp" data-wow-delay=".8s">
              <div class="product-collection-item">
                <div class="product-image">
                  <img src="/assets/img/product/23.jpg" alt="img">
                  <div class="product-btn">
                    <a href="/shop-cart" class="theme-btn-2">Add To Cart</a>
                  </div>
                </div>
                <div class="product-content">
                  <p>Fanning</p>
                  <h4>
                    <a href="/product-details/1">Grande Cosmetics Grande</a>
                  </h4>
                  <span>
                    $102.00
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Cosmetics Collection Section Start -->
    <section class="cosmetics-collection-section fix section-padding">
      <div class="container">
        <div class="cosmetics-collection-wrapper">
          <div class="row g-4">
            <div class="col-lg-7 wow fadeInUp" data-wow-delay=".3s">
              <div class="cosmetics-items-bg bg-cover" style="background-image: url('/assets/img/collection/bg-1.jpg');">
                <div class="content">
                  <span>Cosmetics Collection</span>
                  <h3>
                    Foundation and <br>
                    powder brush
                  </h3>
                  <a href="/product-details/1" class="theme-btn">Discover Now <i class="fa-regular fa-arrow-right"></i></a>
                </div>
              </div>
            </div>
            <div class="col-lg-5 wow fadeInUp" data-wow-delay=".5s">
              <div class="cosmetics-items-bg bg-cover" style="background-image: url('/assets/img/collection/bg-2.jpg');">
                <div class="content style-2">
                  <h3>
                    best cosmetics For Hair and skin
                  </h3>
                  <a href="/product-details/1" class="link-btn">Shop Collection</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- cta-cosmetics Collection Section Start -->
    <div class="cta-cosmetics-section fix">
      <div class="container">
        <div class="cosmetics-wrap bg-cover" style="background-image: url(/assets/img/bg.jpg);">
          <h2 class="text-white wow fadeInUp" data-wow-delay=".3s">
            Discover our Beauty Selection <br>75% Extra Discount for your..
          </h2>
          <div class="coming-soon-timer wow fadeInUp" data-wow-delay=".5s">
            <div class="timer-content">
              <h3 id="day">00</h3>
              <p>Days</p>
            </div>
            <div class="timer-content">
              <h3 id="hour">00</h3>
              <p>hrs</p>
            </div>
            <div class="timer-content">
              <h3 id="min">00</h3>
              <p>mins</p>
            </div>
            <div class="timer-content">
              <h3 id="sec">00</h3>
              <p>secs</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Product-collection Section Start -->
    <section class="product-collection-section-2 section-padding fix">
      <div class="container">
        <div class="section-title-area">
          <div class="section-title style-3">
            <h6 class="sub-title wow fadeInUp">
              Best Seller This Week's
            </h6>
            <h2 class="wow fadeInUp" data-wow-delay=".3s">
              Enjoy the best quality
            </h2>
          </div>
          <ul class="nav">
            <li class="nav-item wow fadeInUp" data-wow-delay=".3s">
              <a href="#All" data-bs-toggle="tab" class="nav-link active">
                All Collection
              </a>
            </li>
            <li class="nav-item wow fadeInUp" data-wow-delay=".5s">
              <a href="#Trending" data-bs-toggle="tab" class="nav-link">
                Trending
              </a>
            </li>
            <li class="nav-item wow fadeInUp" data-wow-delay=".5s">
              <a href="#Beauty" data-bs-toggle="tab" class="nav-link">
                Beauty
              </a>
            </li>
            <li class="nav-item wow fadeInUp" data-wow-delay=".5s">
              <a href="#Cosmetics" data-bs-toggle="tab" class="nav-link bb-none">
                Cosmetics
              </a>
            </li>
          </ul>
        </div>
        <div class="tab-content">
          <div id="All" class="tab-pane fade show active">
            <div class="row">
              <div class="col-xl-3 col-lg-4 col-md-6">
                <div class="product-collection-item">
                  <div class="product-image">
                    <img src="/assets/img/product/24.jpg" alt="img">
                    <div class="product-btn">
                      <a href="/shop-cart" class="theme-btn-2">Add To Cart</a>
                    </div>
                  </div>
                  <div class="product-content">
                    <p>Physicians</p>
                    <h4>
                      <a href="/product-details/1">Powder Creamy Natural</a>
                    </h4>
                    <ul class="doller">
                      <li>
                        $102.00 <del>$226.00</del>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="col-xl-3 col-lg-4 col-md-6">
                <div class="product-collection-item">
                  <div class="product-image">
                    <img src="/assets/img/product/25.jpg" alt="img">
                    <div class="badge">26%</div>
                    <div class="product-btn">
                      <a href="/shop-cart" class="theme-btn-2">Add To Cart</a>
                    </div>
                  </div>
                  <div class="product-content">
                    <p>Mineral </p>
                    <h4>
                      <a href="/product-details/1">Mineral Matte Finishing</a>
                    </h4>
                    <span>$16.00</span>
                  </div>
                </div>
              </div>
              <div class="col-xl-3 col-lg-4 col-md-6">
                <div class="product-collection-item">
                  <div class="product-image">
                    <img src="/assets/img/product/26.jpg" alt="img">
                    <div class="product-btn active">
                      <a href="/shop-cart" class="theme-btn-2">Add To Cart</a>
                    </div>
                  </div>
                  <div class="product-content">
                    <p>StriVectin</p>
                    <h4>
                      <a href="/product-details/1">Resurfacing Exfoliating</a>
                    </h4>
                    <ul class="doller">
                      <li>
                        $76.00 <del>$106.00</del>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="col-xl-3 col-lg-4 col-md-6">
                <div class="product-collection-item">
                  <div class="product-image">
                    <img src="/assets/img/product/27.jpg" alt="img">
                    <div class="badge">35%</div>
                    <div class="product-btn">
                      <a href="/shop-cart" class="theme-btn-2">Add To Cart</a>
                    </div>
                  </div>
                  <div class="product-content">
                    <p>Marcelle</p>
                    <h4>
                      <a href="/product-details/1">Correction Tinted Cream</a>
                    </h4>
                    <span>$44.00</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="Trending" class="tab-pane fade">
            <div class="row">
              <div class="col-xl-3 col-lg-4 col-md-6">
                <div class="product-collection-item">
                  <div class="product-image">
                    <img src="/assets/img/product/24.jpg" alt="img">
                    <div class="product-btn">
                      <a href="/shop-cart" class="theme-btn-2">Add To Cart</a>
                    </div>
                  </div>
                  <div class="product-content">
                    <p>Physicians</p>
                    <h4>
                      <a href="/product-details/1">Powder Creamy Natural</a>
                    </h4>
                    <ul class="doller">
                      <li>
                        $102.00 <del>$226.00</del>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

  <!-- Shop-section Start -->
  <section class="shop-collection-section fix">
    <div class="container">
      <div class="shop-wrapper-2">
        <div class="row g-2">
          <div class="col-lg-5 wow fadeInUp" data-wow-delay=".3s">
            <div class="shop-collection-image">
              <img src="/assets/img/shop/12.jpg" alt="img">
              <div class="banner-product">
                <div class="product-details">
                  <h4 class="title"><a href="/product-details/1">Night Face</a></h4>
                  <div class="price">$15.22 - $15.22</div>
                  <div class="rating-image">
                    <img src="/assets/img/cart/cream.jpg" alt="img">
                  </div>
                </div>
                <div class="plus-icon ripple">
                  <i class="far fa-plus"></i>
                </div>
              </div>
              <div class="banner-product style-2">
                <div class="product-details">
                  <h4 class="title"><a href="/product-details/1">Night Face</a></h4>
                  <div class="price">$15.22 - $15.22</div>
                  <div class="rating-image">
                    <img src="/assets/img/cart/cream.jpg" alt="img">
                  </div>
                </div>
                <div class="plus-icon ripple ">
                  <i class="far fa-plus"></i>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-7">
            <div class="shop-right-items">
              <div class="section-title style-3">
                <h6 class="sub-title wow fadeInUp">
                  Trending This Week's
                </h6>
                <h2 class="wow fadeInUp" data-wow-delay=".3s">
                  Special products
                </h2>
              </div>
              <div class="swiper product-slider-2">
                <div class="swiper-wrapper">
                  <div class="swiper-slide">
                    <div class="right-image">
                      <img src="/assets/img/shop/13.jpg" alt="img">
                    </div>
                    <p class="wow fadeInUp" data-wow-delay=".3s">Night Face</p>
                    <h4 class="wow fadeInUp" data-wow-delay=".5s">Retinol Value Set Duo</h4>
                    <ul class="doller wow fadeInUp" data-wow-delay=".7s">
                      <li>
                        $124.00 <del>$126.00</del>
                      </li>
                    </ul>
                  </div>
                  <div class="swiper-slide">
                    <div class="right-image">
                      <img src="/assets/img/shop/13.jpg" alt="img">
                    </div>
                    <p class="wow fadeInUp" data-wow-delay=".3s">Night Face</p>
                    <h4 class="wow fadeInUp" data-wow-delay=".5s">Retinol Value Set Duo</h4>
                    <ul class="doller wow fadeInUp" data-wow-delay=".7s">
                      <li>
                        $124.00 <del>$126.00</del>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="arrow-button">
                <button class="array-prev">
                  <i class="fa-light fa-chevron-left"></i>
                </button>
                <button class="array-next">
                  <i class="fa-light fa-chevron-right"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Testimonial-Section Start -->
  <section class="testimonial-section section-padding fix">
    <div class="container">
      <div class="section-title text-center style-3">
        <h6 class="sub-title wow fadeInUp">
          Customers Review
        </h6>
        <h2 class="wow fadeInUp" data-wow-delay=".3s">
          What our Clients say
        </h2>
      </div>
      <div class="swiper testimonial-slider">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <div class="testimonial-box-item">
              <div class="testimonial-content">
                <div class="star">
                  <i class="fa-solid fa-star"></i>
                  <i class="fa-solid fa-star"></i>
                  <i class="fa-solid fa-star"></i>
                  <i class="fa-duotone fa-solid fa-star"></i>
                </div>
                <p>
                  Suscipit tellus mauris a diam maecenas. Ut faucibus pulvinar elementum integer enim neque volutpat ac. Auctor urna nunc id cursus. Scelerisque purus semper eget duis at. Pharetra vel turpis nunc eget.
                </p>
                <div class="client-info-item">
                  <div class="client-info">
                    <div class="client-image">
                      <img src="/assets/img/testimonial/client-1.png" alt="img">
                    </div>
                    <div class="text">
                      <h6>Jake Weary / <span>Product Designer</span></h6>
                    </div>
                  </div>
                  <div class="shape-image">
                    <img src="/assets/img/testimonial/shape.png" alt="img">
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-slide">
            <div class="testimonial-box-item">
              <div class="testimonial-content">
                <div class="star">
                  <i class="fa-solid fa-star"></i>
                  <i class="fa-solid fa-star"></i>
                  <i class="fa-solid fa-star"></i>
                  <i class="fa-duotone fa-solid fa-star"></i>
                </div>
                <p>
                  Suscipit tellus mauris a diam maecenas. Ut faucibus pulvinar elementum integer enim neque volutpat ac. Auctor urna nunc id cursus. Scelerisque purus semper eget duis at. Pharetra vel turpis nunc eget.
                </p>
                <div class="client-info-item">
                  <div class="client-info">
                    <div class="client-image">
                      <img src="/assets/img/testimonial/client-2.png" alt="img">
                    </div>
                    <div class="text">
                      <h6>Penny Tool / <span>Product Designer</span></h6>
                    </div>
                  </div>
                  <div class="shape-image">
                    <img src="/assets/img/testimonial/shape.png" alt="img">
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-slide">
            <div class="testimonial-box-item">
              <div class="testimonial-content">
                <div class="star">
                  <i class="fa-solid fa-star"></i>
                  <i class="fa-solid fa-star"></i>
                  <i class="fa-solid fa-star"></i>
                  <i class="fa-duotone fa-solid fa-star"></i>
                </div>
                <p>
                  Suscipit tellus mauris a diam maecenas. Ut faucibus pulvinar elementum integer enim neque volutpat ac. Auctor urna nunc id cursus. Scelerisque purus semper eget duis at. Pharetra vel turpis nunc eget.
                </p>
                <div class="client-info-item">
                  <div class="client-info">
                    <div class="client-image">
                      <img src="/assets/img/testimonial/client-1.png" alt="img">
                    </div>
                    <div class="text">
                      <h6>Jake Weary / <span>Product Designer</span></h6>
                    </div>
                  </div>
                  <div class="shape-image">
                    <img src="/assets/img/testimonial/shape.png" alt="img">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="swiper-dot3 mt-5">
        <div class="dot"></div>
      </div>
    </div>
  </section>

  <!-- Feature-Section Start -->
  <section class="feature-section-2 section-padding pt-0 fix">
    <div class="container">
      <div class="feature-wrapper style-2">
        <div class="feature-item style-2 wow fadeInUp" data-wow-delay=".2s">
          <div class="icon">
            <img src="/assets/img/icon/05.svg" alt="img">
          </div>
          <div class="content">
            <h6>
              Free Delivary
            </h6>
            <p>Orders from all item</p>
          </div>
        </div>
        <div class="feature-item wow fadeInUp" data-wow-delay=".4s">
          <div class="icon">
            <img src="/assets/img/icon/06.svg" alt="img">
          </div>
          <div class="content">
            <h6>
              Return & Refunf
            </h6>
            <p>Maney back guarantee</p>
          </div>
        </div>
        <div class="feature-item wow fadeInUp" data-wow-delay=".6s">
          <div class="icon">
            <img src="/assets/img/icon/07.svg" alt="img">
          </div>
          <div class="content">
            <h6>
              Member Discount
            </h6>
            <p>Onevery order over $140.00</p>
          </div>
        </div>
        <div class="feature-item wow fadeInUp" data-wow-delay=".8s">
          <div class="icon">
            <img src="/assets/img/icon/08.svg" alt="img">
          </div>
          <div class="content">
            <h6>
              Support 24/7
            </h6>
            <p>Contact us 24 hours a day</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- News-section Start -->
  <section class="news-section fix section-padding pt-0">
    <div class="container">
      <div class="section-title-area">
        <div class="section-title style-3">
          <h6 class="sub-title wow fadeInUp">
            Our Blog & News
          </h6>
          <h2 class="wow fadeInUp" data-wow-delay=".3s">
            Latest News & Articles
          </h2>
        </div>
        <a href="/news" class="theme-btn theme-btn-3 border-color wow fadeInUp" data-wow-delay=".5s">Discover More</a>
      </div>
      <div class="row">
        <div class="col-xl-4 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay=".3s">
          <div class="news-card-items style-2">
            <div class="news-image">
              <img src="/assets/img/news/04.jpg" alt="img">
              <h6 class="side-box">14 July, 2025</h6>
            </div>
            <div class="news-content">
              <ul class="post-meta">
                <li>
                  Beauty, Jan 1, 2025
                </li>
              </ul>
              <h3>
                <a href="/news">Best New Beauty Products to Shop in August.</a>
              </h3>
            </div>
          </div>
        </div>
        <div class="col-xl-4 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay=".5s">
          <div class="news-card-items style-2">
            <div class="news-image">
              <img src="/assets/img/news/05.jpg" alt="img">
              <h6 class="side-box">14 July, 2025</h6>
            </div>
            <div class="news-content">
              <ul class="post-meta">
                <li>
                  Beauty, Jan 1, 2025
                </li>
              </ul>
              <h3>
                <a href="/news">A Perfect way to make your fingernail shiny and adorable.</a>
              </h3>
            </div>
          </div>
        </div>
        <div class="col-xl-4 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay=".7s">
          <div class="news-card-items style-2">
            <div class="news-image">
              <img src="/assets/img/news/06.jpg" alt="img">
              <h6 class="side-box">14 July, 2025</h6>
            </div>
            <div class="news-content">
              <ul class="post-meta">
                <li>
                  Beauty, Jan 1, 2025
                </li>
              </ul>
              <h3>
                <a href="/news">All Essential Carings your Skin wants you to Do at Night</a>
              </h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Instagram Banner Section Start -->
 
  <!-- footer-section Start -->
 
    <!-- Newsletter Modal Area Start-->
    <div class="modal fade bd-example-modal-lg common-newsletter-modal" id="exampleModal" tabindex="-1" role="dialog"
      aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body modal1 modal-bg">
            <div class="row">
              <div class="col-12">
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>

              </div>
              <div class="col-lg-12">
                <div class="row align-items-center">
                  <div class="col-lg-5 col-md-12">
                    <div class="offer-modal-img d-none d-lg-block">
                      <img src="/assets/img/cart/common-modal.jpg" alt="img">
                    </div>
                  </div>
                  <div class="col-lg-7 col-md-12">
                    <div class="offer-modal-right">
                      <h3>Subcribe to Our Newsletter</h3>
                      <p>Subscribe to our newsletter and Save your <span>20% money</span> with
                        discount code today.</p>
                      <form action="#!">
                        <div class="input-group mb-3">
                          <input type="text" class="form-control" placeholder="Enter your email">
                          <div class="input-group-append">
                            <button class="theme-btn style-2">Subscribe</button>
                          </div>
                        </div>
                        <div class="check-boxed-modal">
                          <input type="checkbox" id="vehicle1" name="vehicle1" value="Bike">
                          <label for="vehicle1">Do not show this window</label>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </SharedLayout>
</template>

<script>
import { onMounted } from 'vue'
import SharedLayout from '../components/SharedLayout.vue'

export default {
  name: 'HomePage',
  components: {
    SharedLayout
  },
  setup() {
    onMounted(() => {
      // Initialize jQuery plugins and custom JS
      if (window.$) {
        // Sidebar Toggle
        $(".offcanvas__close,.offcanvas__overlay").on("click", function() {
          $(".offcanvas__info").removeClass("info-open");
          $(".offcanvas__overlay").removeClass("overlay-open");
        });
        $(".sidebar__toggle").on("click", function() {
          $(".offcanvas__info").addClass("info-open");
          $(".offcanvas__overlay").addClass("overlay-open");
        });

        // Sticky Header
        $(window).on("scroll", function() {
          if ($(this).scrollTop() > 250) {
            $("#header-sticky").addClass("sticky");
          } else {
            $("#header-sticky").removeClass("sticky");
          }
        });

        // Sidebar Area
        $("#openButton").on("click", function(e) {
          e.preventDefault();
          $("#targetElement").removeClass("side_bar_hidden");
        });
        $("#closeButton").on("click", function(e) {
          e.preventDefault();
          $("#targetElement").addClass("side_bar_hidden");
        });

        // Video Popup
        $('.img-popup').magnificPopup({
          type: "image",
          gallery: { enabled: true },
        });
        $('.video-popup').magnificPopup({
          type: 'iframe'
        });

        // Counterup
        $(".count").counterUp({
          delay: 15,
          time: 4000,
        });

        // Wow Animation
        new WOW().init();

        // Nice Select
        $('select').niceSelect();

        // Swiper Sliders
        if($('.hero-slider').length > 0) {
          const heroSlider = new Swiper(".hero-slider", {
            loop: true,
            slidesPerView: 1,
            effect: "fade",
            speed: 3000,
            autoplay: { delay: 3000, disableOnInteraction: false },
            navigation: { nextEl: ".array-prev", prevEl: ".array-next" },
            pagination: { el: ".dot", clickable: true },
          });
        }

        if($('.category-slider').length > 0) {
          const categorySlider = new Swiper(".category-slider", {
            spaceBetween: 20,
            speed: 1300,
            loop: true,
            autoplay: { delay: 2000, disableOnInteraction: false },
            navigation: { nextEl: ".array-prev", prevEl: ".array-next" },
            breakpoints: {
              1199: { slidesPerView: 4 },
              991: { slidesPerView: 3 },
              767: { slidesPerView: 2 },
              575: { slidesPerView: 2 },
              0: { slidesPerView: 1 },
            },
          });
        }

        // Countdown Timer
        let targetDate = new Date("2025-05-8 00:00:00").getTime();
        const countdownInterval = setInterval(function () {
          let currentDate = new Date().getTime();
          let remainingTime = targetDate - currentDate;
          if (remainingTime <= 0) {
            clearInterval(countdownInterval);
          } else {
            let days = Math.floor(remainingTime / (1000 * 60 * 60 * 24));
            let hours = Math.floor((remainingTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            let minutes = Math.floor((remainingTime % (1000 * 60 * 60)) / (1000 * 60));
            let seconds = Math.floor((remainingTime % (1000 * 60)) / 1000);
            $("#day").text(days.toString().padStart(2, "0"));
            $("#hour").text(hours.toString().padStart(2, "0"));
            $("#min").text(minutes.toString().padStart(2, "0"));
            $("#sec").text(seconds.toString().padStart(2, "0"));
          }
        }, 1000);

        // Search Popup
        $(".search-trigger").on("click", function (e) {
          e.preventDefault();
          $(".search-wrap").animate({ opacity: "toggle" }, 500);
          $(".nav-search, #search-close").addClass("open");
        });
        $(".search-close").on("click", function (e) {
          e.preventDefault();
          $(".search-wrap").animate({ opacity: "toggle" }, 500);
          $(".nav-search, #search-close").removeClass("open");
        });

        // Back to Top
        $(window).on('scroll', function() {
          if ($(this).scrollTop() > 20) {
            $("#back-top").addClass("show");
          } else {
            $("#back-top").removeClass("show");
          }
        });
        $(document).on('click', '#back-top', function() {
          $('html, body').animate({ scrollTop: 0 }, 800);
          return false;
        });

        // Preloader
        $(window).on('load', function() {
          $(".preloader").addClass('loaded');
          $(".preloader").delay(600).fadeOut();
        });
      }
    });

    return {};
  }
}
</script>